import { Components } from '@mui/material'

/**
 * Surface defaults for the Intent Intelligence look: flat warm surfaces (no elevation overlay) and
 * hairline card borders drawn with the theme `divider` token, matching About.tsx's restrained
 * card/panel treatment.
 */
const MuiSurfaces: Components = {
  MuiPaper: {
    styleOverrides: {
      // Kill MUI's elevation-overlay gradient so paper surfaces read as the flat warm token.
      root: {
        backgroundImage: 'none',
      },
    },
  },
  MuiCard: {
    styleOverrides: {
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      root: ({ theme }: { theme: any }) => ({
        backgroundImage: 'none',
        border: `1px solid ${theme.palette.divider}`,
        borderRadius: 4,
      }),
    },
  },
}

export default MuiSurfaces
